import {
    DFM_WARNING,
    DFM_FAILURE,
    DFM_COST_DRIVER,
    DFM_NOTICE,
} from '~/lib/partsConstants'

export const TAG_COLOR: { [key: string]: string } = {
    [DFM_FAILURE]: 'red',
    [DFM_NOTICE]: 'green',
    [DFM_WARNING]: 'gold',
    [DFM_COST_DRIVER]: 'blue',
}
